import {
  FlexibleBlockProps,
  FlexibleBlockTemplateLimit,
  FlexibleBlockBrickTitle,
  FlexibleBlockBrickProgress,
  TailwindCommonPalette,
  PortalBgType,
} from '@nx-frontend/shared/types';
import { getWrapperProps } from '@nx-frontend/shared/utils/blocks';
import { brickCommon } from './common';

export const getLimitBlockTemplate = (): FlexibleBlockProps<FlexibleBlockTemplateLimit>[] => {
  const brickTitle: FlexibleBlockBrickTitle = {
    ...brickCommon,
    brickType: 'title',
    brickName: 'Title',
    text: 'Description',
    placeholder: 'Type description here',
  };

  const brickProgress: FlexibleBlockBrickProgress = {
    ...brickCommon,
    brickType: 'progress',
    brickName: 'Progress',
    value: 33,
    limit: 100,
    unit: 'units',
    colored: false,
    showButton: false,
    buttonText: 'Button',
    theme: {
      bg: {
        low: [TailwindCommonPalette.GREEN_500],
        middle: [TailwindCommonPalette.YELLOW_400],
        high: [TailwindCommonPalette.RED_500],
        themeColor: PortalBgType.SURFACE,
      },
    },
  };

  const block: FlexibleBlockProps<FlexibleBlockTemplateLimit> = {
    title: 'Limit',
    wrapper: getWrapperProps('blank'),
    template: {
      type: 'limit',
      view: 'basic',
    },
    bricks: [
      { ...brickTitle, index: 0 },
      { ...brickProgress, index: 1 },
    ],
    className: [],
  };

  return [block];
};
